(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magniflex-sleep-quiz"] && !Shopify.designMode) return;
  try {
    

(() => {
  "use strict";

  const GLOBAL_KEY = "MagniflexSleepQuizV9";

  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].initAll();
    return;
  }

  const PRODUCT_ORDER = ["dolce", "magnicool", "roma", "massaggio", "firenze"];
  const STEP_ORDER = ["intro", "q1", "q2", "q3", "q4", "contact", "result"];

  const ANSWERS = {
    Q1_A: {
      label: "Bulutsu ve sarmalayıcı bir lüks konfor arıyorum.",
      scores: { dolce: 5, magnicool: 0, roma: 0, massaggio: 2, firenze: 0 }
    },
    Q1_B: {
      label: "Güçlü, net ve dinamik bir omurga desteği istiyorum.",
      scores: { dolce: 2, magnicool: 4, roma: 5, massaggio: 1, firenze: 3 }
    },
    Q1_C: {
      label: "Yataktan tamamen yenilenmiş ve canlanmış kalkmak istiyorum.",
      scores: { dolce: 2, magnicool: 1, roma: 3, massaggio: 5, firenze: 1 }
    },
    Q1_D: {
      label: "Güvenilir, dengeli ve sade bir İtalyan klasiği arıyorum.",
      scores: { dolce: 1, magnicool: 1, roma: 3, massaggio: 1, firenze: 5 }
    },

    Q2_A: {
      label: "Partnerimle farklı sertlik tercihlerimiz ve hareket yansımaları.",
      scores: { dolce: 5, magnicool: 1, roma: 1, massaggio: 1, firenze: 1 }
    },
    Q2_B: {
      label: "Vücut ısımın değişmesi ve terleme.",
      scores: { dolce: 1, magnicool: 5, roma: 1, massaggio: 1, firenze: 3 }
    },
    Q2_C: {
      label: "Kas gerginliği ve doğru pozisyonu bulamamak.",
      scores: { dolce: 3, magnicool: 1, roma: 3, massaggio: 5, firenze: 1 }
    },
    Q2_D: {
      label: "Sıradan malzemelerin yarattığı havasızlık hissi.",
      scores: { dolce: 2, magnicool: 4, roma: 2, massaggio: 2, firenze: 5 }
    },

    Q3_A: {
      label: "Kusursuz esneklik ve kişiye özel lüks.",
      scores: { dolce: 5, magnicool: 1, roma: 1, massaggio: 1, firenze: 1 }
    },
    Q3_B: {
      label: "İleri teknoloji, serinlik ve tazelik.",
      scores: { dolce: 1, magnicool: 5, roma: 1, massaggio: 3, firenze: 1 }
    },
    Q3_C: {
      label: "Bedenime gösterdiğim bilimsel ve medikal özen.",
      scores: { dolce: 2, magnicool: 3, roma: 5, massaggio: 4, firenze: 2 }
    },
    Q3_D: {
      label: "Yalınlık, kalite ve İtalyan zanaatı.",
      scores: { dolce: 3, magnicool: 2, roma: 2, massaggio: 2, firenze: 5 }
    },

    Q4_A: {
      label: "Benim için uykunun tanımı: En lüks ev ritüeli.",
      scores: { dolce: 5, magnicool: 1, roma: 1, massaggio: 2, firenze: 1 }
    },
    Q4_B: {
      label: "Benim için uykunun tanımı: Kasları şarj etme süresi.",
      scores: { dolce: 1, magnicool: 1, roma: 3, massaggio: 5, firenze: 1 }
    },
    Q4_C: {
      label: "Benim için uykunun tanımı: Zihinsel ve bedensel reset.",
      scores: { dolce: 2, magnicool: 4, roma: 5, massaggio: 3, firenze: 1 }
    },
    Q4_D: {
      label: "Benim için uykunun tanımı: Güven veren, sade bir rahatlık.",
      scores: { dolce: 1, magnicool: 1, roma: 3, massaggio: 1, firenze: 5 }
    }
  };

  function escapeHtml(value) {
    return String(value ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function parseApiError(data, fallback) {
    return data?.errors?.[0]?.detail || data?.description || fallback;
  }

  class MagniflexQuiz {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId || "";
      this.modal = root.querySelector("[data-mq-modal]");
      this.configNode = root.querySelector("[data-mq-config]");

      if (!this.modal || !this.configNode) {
        throw new Error("Magniflex quiz yapılandırması bulunamadı.");
      }

      this.config = JSON.parse(this.configNode.textContent);
      this.form = this.modal.querySelector("[data-mq-form]");
      this.shopifySubscribeForm = this.root.querySelector(".mq-shopify-subscribe-form");
      this.steps = Array.from(this.modal.querySelectorAll("[data-mq-step]"));
      this.progressHeader = this.modal.querySelector("[data-mq-progress-header]");
      this.progressBar = this.modal.querySelector("[data-mq-progress-bar]");
      this.progressText = this.modal.querySelector("[data-mq-progress-text]");
      this.resultContainer = this.modal.querySelector("[data-mq-results]");
      this.emailInput = this.modal.querySelector("[data-mq-email]");
      this.firstNameInput = this.modal.querySelector("[data-mq-first-name]");
      this.consentInput = this.modal.querySelector("[data-mq-consent]");
      this.submitButton = this.modal.querySelector("[data-mq-submit]");
      this.submitText = this.modal.querySelector("[data-mq-submit-text]");
      this.spinner = this.modal.querySelector("[data-mq-spinner]");
      this.sideTrigger = this.root.querySelector("[data-mq-side-trigger]");
      this.sideTriggerOpenButton = this.root.querySelector("[data-mq-side-open]");
      this.sideTriggerDismissButton = this.root.querySelector("[data-mq-side-dismiss]");
      this.sideTriggerLabel = this.root.querySelector("[data-mq-side-trigger-label]");

      this.activeStep = "intro";
      this.lastFocusedElement = null;
      this.resultState = null;
      this.isOpen = false;
      this.sideTriggerAvailable =
        this.hasSideTriggerAvailableInSession() && !this.hasSideTriggerDismissedInSession();
      this.pendingSideTriggerAfterClose = false;

      this.bind();
      this.updateSideTrigger();
      this.scheduleAutoOpen();
    }

    updateSideTrigger() {
      if (!this.sideTrigger || !this.sideTriggerLabel) return;

      let label = "Uyku Testi";
      let ariaLabel = "Uyku testini aç";

      if (this.activeStep === "result") {
        label = "Sonucumu Gör";
        ariaLabel = "Uyku testi sonucunu yeniden aç";
      } else if (this.activeStep !== "intro") {
        label = "Teste Devam Et";
        ariaLabel = "Uyku testine kaldığınız yerden devam et";
      }

      this.sideTriggerLabel.textContent = label;
      this.sideTriggerOpenButton?.setAttribute("aria-label", ariaLabel);
      this.sideTrigger.hidden = !(
        this.sideTriggerAvailable &&
        !this.hasSideTriggerDismissedInSession() &&
        !this.isOpen
      );
    }

    getDiscountData() {
      const code = this.config.discountEnabled
        ? String(this.config.discountCode || "").trim()
        : "";
      const percent = this.config.discountEnabled
        ? Math.max(0, Number(this.config.discountPercent || 0))
        : 0;

      return {
        enabled: Boolean(code && percent > 0),
        code,
        percent
      };
    }

    getAutoOpenStorageKey() {
      return `magniflex-quiz-v9-auto-opened-${this.sectionId || "default"}`;
    }

    getSideTriggerStorageKey() {
      return `magniflex-quiz-v9-side-trigger-${this.sectionId || "default"}`;
    }

    getSideTriggerDismissedStorageKey() {
      return `magniflex-quiz-v12-side-trigger-dismissed-${this.sectionId || "default"}`;
    }

    markAutoOpenSeen() {
      if (!this.config.autoOpenOncePerSession) return;

      try {
        window.sessionStorage.setItem(this.getAutoOpenStorageKey(), "1");
      } catch (error) {
        console.warn("[Magniflex Quiz] Oturum kaydı oluşturulamadı:", error);
      }
    }

    hasAutoOpenedInSession() {
      if (!this.config.autoOpenOncePerSession) return false;

      try {
        return window.sessionStorage.getItem(this.getAutoOpenStorageKey()) === "1";
      } catch (error) {
        return false;
      }
    }

    markSideTriggerAvailable() {
      try {
        window.sessionStorage.setItem(this.getSideTriggerStorageKey(), "1");
      } catch (error) {
        console.warn("[Magniflex Quiz] Yan buton oturum kaydı oluşturulamadı:", error);
      }
    }

    hasSideTriggerAvailableInSession() {
      try {
        return window.sessionStorage.getItem(this.getSideTriggerStorageKey()) === "1";
      } catch (error) {
        return false;
      }
    }

    markSideTriggerDismissed() {
      try {
        window.sessionStorage.setItem(this.getSideTriggerDismissedStorageKey(), "1");
        window.sessionStorage.removeItem(this.getSideTriggerStorageKey());
      } catch (error) {
        console.warn("[Magniflex Quiz] Yan sekme kapatma kaydı oluşturulamadı:", error);
      }
    }

    hasSideTriggerDismissedInSession() {
      try {
        return window.sessionStorage.getItem(this.getSideTriggerDismissedStorageKey()) === "1";
      } catch (error) {
        return false;
      }
    }

    dismissSideTrigger() {
      this.sideTriggerAvailable = false;
      this.pendingSideTriggerAfterClose = false;
      this.markSideTriggerDismissed();
      this.updateSideTrigger();
    }

    scheduleAutoOpen() {
      if (!this.config.autoOpenEnabled) return;
      if (!["index", "product"].includes(String(this.config.pageType || ""))) return;

      /*
       * Popup bu oturumda daha önce gösterilip kapatıldıysa tekrar otomatik açılmaz.
       * Bu durumda kapatmadan sonra aktif edilen yan sekme görünmeye devam eder.
       */
      if (this.hasAutoOpenedInSession()) {
        this.sideTriggerAvailable =
        this.hasSideTriggerAvailableInSession() && !this.hasSideTriggerDismissedInSession();
        this.updateSideTrigger();
        return;
      }

      const requestedDelay = Number(this.config.autoOpenDelayMs || 180000);
      const delay = Math.min(300000, Math.max(1000, requestedDelay));

      window.setTimeout(() => {
        if (!document.documentElement.contains(this.root)) return;
        if (this.isOpen || this.hasAutoOpenedInSession()) return;

        this.open({ autoOpened: true });
      }, delay);
    }

    bind() {
      this.root.querySelectorAll("[data-mq-open]").forEach((button) => {
        button.addEventListener("click", () => this.open());
      });

      this.sideTriggerDismissButton?.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.dismissSideTrigger();
      });

      this.modal.addEventListener("click", (event) => {
        if (event.target.closest("[data-mq-close]")) {
          this.close();
          return;
        }

        if (event.target.closest("[data-mq-start]")) {
          this.goToStep("q1");
          return;
        }

        const nextButton = event.target.closest("[data-mq-next]");
        if (nextButton) {
          this.handleNext(nextButton.dataset.mqNext);
          return;
        }

        if (event.target.closest("[data-mq-back]")) {
          this.goBack();
          return;
        }

        if (event.target.closest("[data-mq-reset]")) {
          this.reset();
        }
      });

      this.form.addEventListener("change", (event) => {
        if (!event.target.matches('input[type="radio"]')) return;
        const match = event.target.name.match(/mq_(q\d)_/);
        if (match) this.clearError(match[1]);
      });

      this.form.addEventListener("submit", (event) => {
        event.preventDefault();
        this.submit();
      });

      this.modal.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          this.close();
          return;
        }
        this.trapFocus(event);
      });
    }

    open(options = {}) {
      const autoOpened = Boolean(options.autoOpened);

      this.lastFocusedElement = document.activeElement;
      this.modal.hidden = false;
      this.modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("mq-modal-open");
      this.isOpen = true;

      if (autoOpened) {
        this.pendingSideTriggerAfterClose = true;
      }

      this.updateSideTrigger();

      window.setTimeout(() => {
        this.modal.querySelector(".mq-close")?.focus();
      }, 20);
    }

    close() {
      this.modal.hidden = true;
      this.modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("mq-modal-open");
      this.isOpen = false;

      if (this.pendingSideTriggerAfterClose) {
        this.pendingSideTriggerAfterClose = false;
        this.markAutoOpenSeen();

        if (!this.hasSideTriggerDismissedInSession()) {
          this.sideTriggerAvailable = true;
          this.markSideTriggerAvailable();
        }
      }

      this.updateSideTrigger();

      if (this.lastFocusedElement && typeof this.lastFocusedElement.focus === "function") {
        this.lastFocusedElement.focus();
      }
    }

    reset() {
      this.form.reset();
      this.resultContainer.innerHTML = "";
      this.resultState = null;
      ["q1", "q2", "q3", "q4", "contact"].forEach((key) => this.clearError(key));
      this.goToStep("intro", false);
    }

    getStep(stepName) {
      return this.modal.querySelector(`[data-mq-step="${stepName}"]`);
    }

    goToStep(stepName, shouldFocus = true) {
      this.activeStep = stepName;
      this.updateSideTrigger();

      this.steps.forEach((step) => {
        step.hidden = step.dataset.mqStep !== stepName;
      });

      this.progressHeader.hidden = !["q1", "q2", "q3", "q4", "contact"].includes(stepName);

      if (!this.progressHeader.hidden) {
        this.updateProgress(stepName);
      }

      this.modal.querySelector(".mq-dialog")?.scrollTo({
        top: 0,
        behavior: "smooth"
      });

      if (!shouldFocus) return;

      window.setTimeout(() => {
        const step = this.getStep(stepName);
        const target = step?.querySelector("legend, h2, h3, input, button");
        if (!target) return;

        if (!target.matches("input, button, a, select, textarea")) {
          target.setAttribute("tabindex", "-1");
        }

        target.focus({ preventScroll: true });
      }, 40);
    }

    updateProgress(stepName) {
      if (stepName.startsWith("q")) {
        const number = Number(stepName.slice(1));
        this.progressBar.style.width = `${number * 25}%`;
        this.progressText.textContent = `${number} / 4`;
        return;
      }

      this.progressBar.style.width = "100%";
      this.progressText.textContent = "Son adım";
    }

    goBack() {
      const index = STEP_ORDER.indexOf(this.activeStep);
      const previousStep = STEP_ORDER[Math.max(0, index - 1)];
      this.goToStep(previousStep);
    }

    handleNext(nextStep) {
      if (this.activeStep.startsWith("q")) {
        const selected = this.getAnswer(this.activeStep);

        if (!selected) {
          this.showError(this.activeStep, "Lütfen bir seçenek belirleyin.");
          return;
        }

        this.clearError(this.activeStep);
      }

      this.goToStep(nextStep);
    }

    getAnswer(questionKey) {
      const escapedSectionId =
        window.CSS && typeof window.CSS.escape === "function"
          ? window.CSS.escape(this.sectionId)
          : this.sectionId.replace(/[^a-zA-Z0-9_-]/g, "");

      return (
        this.form.querySelector(
          `input[name="mq_${questionKey}_${escapedSectionId}"]:checked`
        )?.value || ""
      );
    }

    showError(key, message) {
      const node = this.modal.querySelector(`[data-mq-error="${key}"]`);
      if (!node) return;

      if (message) node.textContent = message;
      node.hidden = false;
    }

    clearError(key) {
      const node = this.modal.querySelector(`[data-mq-error="${key}"]`);
      if (node) node.hidden = true;
    }

    calculate() {
      const answers = {
        q1: this.getAnswer("q1"),
        q2: this.getAnswer("q2"),
        q3: this.getAnswer("q3"),
        q4: this.getAnswer("q4")
      };

      const scores = Object.fromEntries(PRODUCT_ORDER.map((key) => [key, 0]));
      const strongMatches = Object.fromEntries(PRODUCT_ORDER.map((key) => [key, 0]));
      const q2Scores = Object.fromEntries(PRODUCT_ORDER.map((key) => [key, 0]));

      Object.entries(answers).forEach(([question, answerCode]) => {
        const answer = ANSWERS[answerCode];
        if (!answer) return;

        PRODUCT_ORDER.forEach((productKey) => {
          const score = Number(answer.scores[productKey] || 0);
          scores[productKey] += score;

          if (score === 5) strongMatches[productKey] += 1;
          if (question === "q2") q2Scores[productKey] = score;
        });
      });

      const availableProducts = PRODUCT_ORDER.filter(
        (productKey) => this.config.products?.[productKey]
      );

      availableProducts.sort((a, b) => {
        if (scores[b] !== scores[a]) return scores[b] - scores[a];
        if (strongMatches[b] !== strongMatches[a]) {
          return strongMatches[b] - strongMatches[a];
        }
        if (q2Scores[b] !== q2Scores[a]) return q2Scores[b] - q2Scores[a];
        return PRODUCT_ORDER.indexOf(a) - PRODUCT_ORDER.indexOf(b);
      });

      return {
        answers,
        scores,
        strongMatches,
        q2Scores,
        primaryKey: availableProducts[0] || null,
        secondaryKey: availableProducts[1] || null
      };
    }

    validateContact() {
      const firstName = this.firstNameInput.value.trim();
      const email = this.emailInput.value.trim();
      const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      if (!firstName) {
        this.showError("contact", "Lütfen size nasıl hitap etmemizi istediğinizi yazın.");
        this.firstNameInput.focus();
        return false;
      }

      if (!isEmailValid) {
        this.showError("contact", "Lütfen geçerli bir e-posta adresi girin.");
        this.emailInput.focus();
        return false;
      }

      if (!this.consentInput.checked) {
        this.showError(
          "contact",
          "Sonucunuzu e-postayla gönderebilmemiz için iletişim iznini onaylayın."
        );
        this.consentInput.focus();
        return false;
      }

      this.clearError("contact");
      return true;
    }

    async submit() {
      if (!this.validateContact()) return;

      const state = this.calculate();

      if (!state.primaryKey) {
        this.showError(
          "contact",
          "Tema düzenleyicisinden beş Magniflex ürününü bu bölüme seçmeniz gerekiyor."
        );
        return;
      }

      this.resultState = state;
      this.setSubmitting(true);

      try {
        // 1) Shopify müşterisi + e-posta pazarlama aboneliği
        await this.subscribeToShopify();

        // 2) Aynı kişiyi Klaviyo listesine SUBSCRIBED consent ile ekle
        await this.subscribeToKlaviyo(state);

        try {
          await this.sendKlaviyoEvent("Magniflex Uyku Testi Tamamlandı");
        } catch (eventError) {
          console.error("[Magniflex Quiz] Event kaydı oluşturulamadı:", eventError);
        }

        this.renderResults(state);
        this.goToStep("result");
      } catch (error) {
        console.error("[Magniflex Quiz] Abonelik kayıt hatası:", error);
        this.showError(
          "contact",
          error.message || "Kaydınız sırasında bir sorun oluştu. Lütfen tekrar deneyin."
        );
      } finally {
        this.setSubmitting(false);
      }
    }

    setSubmitting(isSubmitting) {
      this.submitButton.disabled = isSubmitting;
      this.spinner.hidden = !isSubmitting;
      this.submitText.textContent = isSubmitting
        ? "Sonucunuz hazırlanıyor…"
        : this.config.submitButtonText || "Kişisel Önerimi Keşfet";
    }

    buildProfileProperties(state) {
      const primary = this.config.products[state.primaryKey];
      const secondary = this.config.products[state.secondaryKey];

      const firstName = this.firstNameInput.value.trim();
      const discount = this.getDiscountData();

      return {
        "Magniflex Müşteri Adı": firstName,
        "Magniflex İndirim Aktif": discount.enabled,
        "Magniflex İndirim Kodu": discount.code,
        "Magniflex İndirim Oranı": discount.percent,

        "Uyku Testi - Soru 1": state.answers.q1,
        "Uyku Testi - Soru 1 Cevap": ANSWERS[state.answers.q1]?.label || "",
        "Uyku Testi - Soru 2": state.answers.q2,
        "Uyku Testi - Soru 2 Cevap": ANSWERS[state.answers.q2]?.label || "",
        "Uyku Testi - Soru 3": state.answers.q3,
        "Uyku Testi - Soru 3 Cevap": ANSWERS[state.answers.q3]?.label || "",
        "Uyku Testi - Soru 4": state.answers.q4,
        "Uyku Testi - Soru 4 Cevap": ANSWERS[state.answers.q4]?.label || "",

        "Magniflex Ana Öneri": primary?.title || state.primaryKey,
        "Magniflex Ana Öneri Anahtarı": state.primaryKey,
        "Magniflex Alternatif Öneri": secondary?.title || state.secondaryKey,
        "Magniflex Alternatif Öneri Anahtarı": state.secondaryKey,

        "Magniflex Dolce Vita Puanı": state.scores.dolce,
        "Magniflex MagniCool Puanı": state.scores.magnicool,
        "Magniflex Roma Puanı": state.scores.roma,
        "Magniflex Massaggio Puanı": state.scores.massaggio,
        "Magniflex Firenze Puanı": state.scores.firenze,

        "Magniflex Quiz Version": "italian-sleep-test-v2",
        "Magniflex Quiz Source URL": window.location.href,
        "Magniflex Quiz Completed At": new Date().toISOString()
      };
    }

    async subscribeToShopify() {
      const form = this.shopifySubscribeForm;

      if (!form) {
        throw new Error("Shopify e-posta abonelik formu bulunamadı.");
      }

      const email = this.emailInput.value.trim();
      const emailField = form.querySelector('[name="contact[email]"]');

      if (!emailField) {
        throw new Error("Shopify e-posta alanı bulunamadı.");
      }

      emailField.value = email;

      // Shopify'ın yerel `customer` newsletter formunu aynı origin üzerinden
      // arka planda gönderiyoruz. Bu form müşteri kaydı oluşturur/günceller
      // ve e-posta pazarlama iznini (accepts_marketing) açar.
      const formData = new FormData(form);
      const body = new URLSearchParams();

      for (const [key, value] of formData.entries()) {
        body.append(key, String(value));
      }

      const response = await fetch(form.action, {
        method: (form.method || "POST").toUpperCase(),
        headers: {
          Accept: "text/html",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        body: body.toString(),
        credentials: "same-origin",
        redirect: "follow"
      });

      if (!response.ok) {
        throw new Error("Shopify e-posta aboneliği oluşturulamadı.");
      }

      // Başarılı newsletter gönderimlerinde Shopify çoğunlukla
      // customer_posted=true parametresiyle geri döner. Tema/market yapısına
      // göre URL değişebildiği için HTTP başarı durumu da kabul edilir.
      const responseHtml = await response.text();
      const responseDocument = new DOMParser().parseFromString(responseHtml, "text/html");
      const returnedForm = responseDocument.getElementById(form.id);

      if (returnedForm) {
        const errorNode = returnedForm.querySelector(
          ".errors, .form__message--error, [data-form-error], [role='alert']"
        );
        const errorText = errorNode?.textContent?.trim();

        if (errorText) {
          throw new Error(errorText);
        }
      }
    }

    async subscribeToKlaviyo(state) {
      const siteId = String(this.config.siteId || "").trim();
      const listId = String(this.config.listId || "").trim();

      if (!siteId || !listId) {
        throw new Error("Klaviyo Site ID veya List ID eksik.");
      }

      const email = this.emailInput.value.trim();
      const firstName = this.firstNameInput.value.trim();

      const profileAttributes = {
        email,
        locale: document.documentElement.lang || "tr-TR",
        properties: this.buildProfileProperties(state),
        subscriptions: {
          email: {
            marketing: {
              consent: "SUBSCRIBED"
            }
          }
        }
      };

      if (firstName) {
        profileAttributes.first_name = firstName;
      }

      const payload = {
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Magniflex İtalyan Uyku Testi",
            profile: {
              data: {
                type: "profile",
                attributes: profileAttributes
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: listId
              }
            }
          }
        }
      };

      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(siteId)}`,
        {
          method: "POST",
          headers: {
            Accept: "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json",
            revision: this.config.subscriptionRevision || "2026-07-15"
          },
          body: JSON.stringify(payload)
        }
      );

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(parseApiError(data, "E-posta kaydı oluşturulamadı."));
      }
    }

    getEventProperties(extraProperties = {}) {
      const state = this.resultState;
      if (!state) return extraProperties;

      const primary = this.config.products[state.primaryKey];
      const secondary = this.config.products[state.secondaryKey];
      const firstName = this.firstNameInput.value.trim();
      const discount = this.getDiscountData();

      return {
        "Customer First Name": firstName,
        "Discount Enabled": discount.enabled,
        "Discount Code": discount.code,
        "Discount Percent": discount.percent,
        "Discount Label": discount.enabled ? `%${discount.percent} Magniflex ayrıcalığı` : "",

        "Primary Recommendation": primary?.title || state.primaryKey,
        "Primary Recommendation Key": state.primaryKey,
        "Secondary Recommendation": secondary?.title || state.secondaryKey,
        "Secondary Recommendation Key": state.secondaryKey,
        "Primary Score": state.scores[state.primaryKey],
        "Secondary Score": state.scores[state.secondaryKey],

        Q1: state.answers.q1,
        Q2: state.answers.q2,
        Q3: state.answers.q3,
        Q4: state.answers.q4,

        "Dolce Vita Score": state.scores.dolce,
        "MagniCool Score": state.scores.magnicool,
        "Roma Score": state.scores.roma,
        "Massaggio Score": state.scores.massaggio,
        "Firenze Score": state.scores.firenze,

        "Quiz Version": "italian-sleep-test-v2",
        "Source URL": window.location.href,
        ...extraProperties
      };
    }

    async sendKlaviyoEvent(metricName, extraProperties = {}) {
      const siteId = String(this.config.siteId || "").trim();
      const email = this.emailInput.value.trim();

      if (!siteId || !email) return;

      const profileAttributes = { email };
      const firstName = this.firstNameInput.value.trim();

      if (firstName) profileAttributes.first_name = firstName;

      const payload = {
        data: {
          type: "event",
          attributes: {
            properties: this.getEventProperties(extraProperties),
            unique_id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
            metric: {
              data: {
                type: "metric",
                attributes: {
                  name: metricName
                }
              }
            },
            profile: {
              data: {
                type: "profile",
                attributes: profileAttributes
              }
            }
          }
        }
      };

      const response = await fetch(
        `https://a.klaviyo.com/client/events?company_id=${encodeURIComponent(siteId)}`,
        {
          method: "POST",
          headers: {
            Accept: "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json",
            revision: this.config.eventRevision || "2026-07-15"
          },
          body: JSON.stringify(payload)
        }
      );

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(parseApiError(data, "Klaviyo event kaydı oluşturulamadı."));
      }
    }

    firstAvailableVariant(product) {
      return (
        product?.variants?.find((variant) => variant.available) ||
        product?.variants?.[0] ||
        null
      );
    }

    formatMoney(cents) {
      const amount = Number(cents || 0) / 100;

      try {
        return new Intl.NumberFormat(this.config.locale || "tr-TR", {
          style: "currency",
          currency: this.config.currency || "TRY",
          minimumFractionDigits: 2
        }).format(amount);
      } catch (error) {
        return `${amount.toFixed(2)} ${this.config.currency || "TRY"}`;
      }
    }

    renderResults(state) {
      this.resultContainer.innerHTML = [
        this.renderProductCard(state.primaryKey, "primary"),
        state.secondaryKey
          ? this.renderProductCard(state.secondaryKey, "secondary")
          : ""
      ].join("");

      this.resultContainer
        .querySelectorAll("[data-mq-product-card]")
        .forEach((card) => this.bindProductCard(card));
    }

    renderProductCard(productKey, role) {
      const product = this.config.products[productKey];
      if (!product) return "";

      const initialVariant = this.firstAvailableVariant(product);
      const badge =
        role === "primary"
          ? "Sizin için ana önerimiz"
          : "Alternatif önerimiz";

      const resultMessage = this.config.resultMessages?.[productKey] || "";
      const image = initialVariant?.image || product.image || "";
      const currentPrice = initialVariant
        ? this.formatMoney(initialVariant.price)
        : "";

      const comparePrice =
        initialVariant &&
        Number(initialVariant.compareAtPrice) > Number(initialVariant.price)
          ? this.formatMoney(initialVariant.compareAtPrice)
          : "";

      const variantOptions = (product.variants || [])
        .map((variant) => {
          const soldOutText = variant.available ? "" : " — Tükendi";
          const isSelected =
            String(variant.id) === String(initialVariant?.id);

          return `
            <option
              value="${escapeHtml(variant.id)}"
              ${isSelected ? "selected" : ""}
              ${variant.available ? "" : "disabled"}
            >
              ${escapeHtml(variant.title)}${soldOutText}
            </option>
          `;
        })
        .join("");

      const shouldShowSelector =
        product.variants?.length > 1 ||
        product.variants?.[0]?.title !== "Default Title";

      return `
        <article
          class="mq-product-card ${
            role === "secondary" ? "mq-product-card--secondary" : ""
          }"
          data-mq-product-card="${escapeHtml(productKey)}"
        >
          <span class="mq-product-badge">${escapeHtml(badge)}</span>

          <div class="mq-product-image-wrap">
            ${
              image
                ? `
                  <img
                    class="mq-product-image"
                    src="${escapeHtml(image)}"
                    alt="${escapeHtml(product.title)}"
                    width="900"
                    height="560"
                    loading="lazy"
                    data-mq-product-image
                  >
                `
                : ""
            }
          </div>

          <div class="mq-product-body">
            <h4 class="mq-product-title">${escapeHtml(product.title)}</h4>
            <p class="mq-product-reason">${escapeHtml(resultMessage)}</p>

            <div class="mq-product-price">
              <span class="mq-price-current" data-mq-current-price>
                ${escapeHtml(currentPrice)}
              </span>

              <span
                class="mq-price-compare"
                data-mq-compare-price
                ${comparePrice ? "" : "hidden"}
              >
                ${escapeHtml(comparePrice)}
              </span>
            </div>

            ${
              shouldShowSelector
                ? `
                  <select
                    class="mq-product-select"
                    aria-label="${escapeHtml(product.title)} varyasyon seçimi"
                    data-mq-variant
                  >
                    ${variantOptions}
                  </select>
                `
                : `
                  <input
                    type="hidden"
                    value="${escapeHtml(initialVariant?.id || "")}"
                    data-mq-variant
                  >
                `
            }

            <div class="mq-product-buttons">
              <button
                type="button"
                class="mq-button"
                data-mq-add
                data-product-key="${escapeHtml(productKey)}"
                ${initialVariant?.available ? "" : "disabled"}
              >
                ${initialVariant?.available ? "Sepete Ekle" : "Stokta Yok"}
              </button>

              <a
                class="mq-product-link"
                href="${escapeHtml(product.url)}"
                data-mq-product-link
                data-product-key="${escapeHtml(productKey)}"
              >
                Ürünü ayrıntılı incele
              </a>
            </div>

            <p class="mq-cart-message" data-mq-cart-message hidden></p>
          </div>
        </article>
      `;
    }

    bindProductCard(card) {
      const productKey = card.dataset.mqProductCard;
      const product = this.config.products[productKey];
      const variantField = card.querySelector("[data-mq-variant]");
      const addButton = card.querySelector("[data-mq-add]");
      const image = card.querySelector("[data-mq-product-image]");
      const currentPrice = card.querySelector("[data-mq-current-price]");
      const comparePrice = card.querySelector("[data-mq-compare-price]");
      const message = card.querySelector("[data-mq-cart-message]");

      if (variantField?.tagName === "SELECT") {
        variantField.addEventListener("change", () => {
          const variant = product.variants.find(
            (item) => String(item.id) === String(variantField.value)
          );

          if (!variant) return;

          currentPrice.textContent = this.formatMoney(variant.price);

          if (Number(variant.compareAtPrice) > Number(variant.price)) {
            comparePrice.textContent = this.formatMoney(variant.compareAtPrice);
            comparePrice.hidden = false;
          } else {
            comparePrice.textContent = "";
            comparePrice.hidden = true;
          }

          if (variant.image && image) image.src = variant.image;

          addButton.disabled = !variant.available;
          addButton.textContent = variant.available
            ? "Sepete Ekle"
            : "Stokta Yok";
        });
      }

      addButton?.addEventListener("click", async () => {
        const variantId =
          variantField?.value || this.firstAvailableVariant(product)?.id;

        if (!variantId) return;

        const originalText = addButton.textContent;
        addButton.disabled = true;
        addButton.textContent = "Ekleniyor…";
        message.hidden = true;

        try {
          await this.addToCart(
            variantId,
            productKey === this.resultState?.primaryKey
              ? "Ana öneri"
              : "Alternatif öneri"
          );

          try {
            await this.sendKlaviyoEvent(
              "Magniflex Önerilen Ürün Sepete Eklendi",
              {
                "Ürün Anahtarı": productKey,
                "Ürün Adı": product.title,
                "Varyant ID": String(variantId),
                "Öneri Türü":
                  productKey === this.resultState?.primaryKey
                    ? "Ana öneri"
                    : "Alternatif öneri"
              }
            );
          } catch (eventError) {
            console.error(
              "[Magniflex Quiz] Sepete ekleme eventi gönderilemedi:",
              eventError
            );
          }

          if (this.config.afterAdd === "cart") {
            window.location.href = this.config.cartUrl || "/cart";
            return;
          }

          addButton.textContent = "Sepete Eklendi";
          message.textContent = "Ürün sepetinize eklendi.";
          message.hidden = false;

          this.refreshThemeCart();

          window.setTimeout(() => {
            addButton.disabled = false;
            addButton.textContent = originalText;
          }, 1800);
        } catch (error) {
          console.error("[Magniflex Quiz] Sepete ekleme hatası:", error);
          addButton.disabled = false;
          addButton.textContent = originalText;
          message.textContent =
            error.message ||
            "Ürün sepete eklenemedi. Lütfen tekrar deneyin.";
          message.hidden = false;
        }
      });

      card.querySelector("[data-mq-product-link]")?.addEventListener("click", () => {
        this.sendKlaviyoEvent(
          "Magniflex Önerilen Ürün Görüntülendi",
          {
            "Ürün Anahtarı": productKey,
            "Ürün Adı": product.title,
            "Öneri Türü":
              productKey === this.resultState?.primaryKey
                ? "Ana öneri"
                : "Alternatif öneri"
          }
        ).catch((error) => {
          console.error(
            "[Magniflex Quiz] Ürün görüntüleme eventi gönderilemedi:",
            error
          );
        });
      });
    }

    async addToCart(variantId, recommendationType) {
      let addUrl = this.config.cartAddUrl || "/cart/add";

      if (!addUrl.endsWith(".js")) {
        addUrl += ".js";
      }

      const response = await fetch(addUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
              properties: {
                "_Magniflex Uyku Testi": recommendationType
              }
            }
          ]
        })
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.description || "Ürün sepete eklenemedi.");
      }

      return response.json();
    }

    refreshThemeCart() {
      const detail = { open: true };

      document.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail
        })
      );

      document.dispatchEvent(
        new CustomEvent("cart:updated", {
          bubbles: true,
          detail
        })
      );
    }

    trapFocus(event) {
      if (event.key !== "Tab" || !this.isOpen) return;

      const focusable = Array.from(
        this.modal.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter(
        (node) =>
          !node.closest("[hidden]") &&
          node.offsetParent !== null
      );

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        last.focus();
        event.preventDefault();
      } else if (!event.shiftKey && document.activeElement === last) {
        first.focus();
        event.preventDefault();
      }
    }
  }

  const api = {
    instances: [],

    initAll(scope = document) {
      scope.querySelectorAll("[data-mq-section]").forEach((root) => {
        if (root.dataset.mqInitialized === "true") return;

        try {
          root.dataset.mqInitialized = "true";
          const instance = new MagniflexQuiz(root);
          api.instances.push(instance);
        } catch (error) {
          root.dataset.mqInitialized = "false";
          console.error("[Magniflex Quiz] Başlatma hatası:", error);
        }
      });
    },

    openFirst() {
      const instance = api.instances.find(
        (item) => document.documentElement.contains(item.root)
      );

      instance?.open();
    }
  };

  window[GLOBAL_KEY] = api;

  function init() {
    api.initAll();

    document.addEventListener("click", (event) => {
      const trigger = event.target.closest(
        '.js-magniflex-quiz-open, a[href$="#magniflex-uyku-testi"]'
      );

      if (!trigger) return;

      event.preventDefault();
      api.openFirst();
    });

    if (window.location.hash === "#magniflex-uyku-testi") {
      window.setTimeout(() => api.openFirst(), 250);
    }

    window.addEventListener("hashchange", () => {
      if (window.location.hash === "#magniflex-uyku-testi") {
        api.openFirst();
      }
    });

    document.addEventListener("shopify:section:load", (event) => {
      api.initAll(event.target);
    });

    document.addEventListener("shopify:section:unload", () => {
      document.body.classList.remove("mq-modal-open");
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();





  } catch(e) { console.error(e); }
})();
})();
